import styled, { theme, useMediaQuery, mediaQuery, css } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { H2, H4 } from 'UIComponents/elements/headings';
import UIBox from 'UIComponents/layout/UIBox';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../utils/usageTracker';
import { getSignupCtaHref } from '../../utils/urls';
import StyledSection from '../publicLayout/components/StyledSection';
import { ThemedPrimaryButton } from '../../components/ThemedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ArrowHolder = styled.div.withConfig({
  displayName: "CertificationProcessSection__ArrowHolder",
  componentId: "sc-1fbzulo-0"
})(["color:", ";height:18px;margin-top:25px;", ";"], theme.colors.EERIE, mediaQuery('tablet', css(["transform:rotate(90deg);margin-top:0;"])));
const ProcessContainer = styled.div.withConfig({
  displayName: "CertificationProcessSection__ProcessContainer",
  componentId: "sc-1fbzulo-1"
})(["display:flex;justify-content:center;flex-direction:column;column-gap:5px;row-gap:20px;align-items:center;", ""], mediaQuery('notTablet', css(["justify-content:center;flex-direction:row;align-items:flex-start;"])));
const ProcessItem = ({
  iconName,
  title,
  description
}) => {
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(UIBox, {
    basis: isTablet ? '0' : '300px',
    style: {
      maxWidth: '300px',
      paddingTop: '30px'
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: "m-bottom-3",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: iconName,
        size: 50
      })
    }), /*#__PURE__*/_jsx(H4, {
      children: title
    }), /*#__PURE__*/_jsx("p", {
      children: description
    })]
  });
};
const CertificationProcessSection = () => {
  const handleSignupCtaClick = hubsSignupCta => {
    usageTracker.track('interaction', {
      action: 'signup-button-click',
      value: hubsSignupCta
    });
  };
  return /*#__PURE__*/_jsx(StyledSection, {
    backgroundColor: theme.colors.HEFFALUMP,
    className: "text-center",
    textColor: theme.colors.OLAF,
    children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "m-bottom-15",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.certificationsProcessSection.title"
        })
      }), /*#__PURE__*/_jsxs(ProcessContainer, {
        className: "m-bottom-15",
        children: [/*#__PURE__*/_jsx(ProcessItem, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsProcessSection.stepOneDescription"
          }),
          iconName: "desktop",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsProcessSection.stepOneTitle"
          })
        }), /*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsx(ArrowHolder, {
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "next",
              size: 30
            })
          })
        }), /*#__PURE__*/_jsx(ProcessItem, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsProcessSection.stepTwoDescription"
          }),
          iconName: "lesson",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsProcessSection.stepTwoTitle"
          })
        }), /*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsx(ArrowHolder, {
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "next",
              size: 30
            })
          })
        }), /*#__PURE__*/_jsx(ProcessItem, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsProcessSection.stepThreeDescription"
          }),
          iconName: "certification",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsProcessSection.stepThreeTitle"
          })
        })]
      }), /*#__PURE__*/_jsx(ThemedPrimaryButton, {
        href: getSignupCtaHref('certifications-overview-bottom'),
        onClick: () => handleSignupCtaClick('certifications-overview-bottom'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.certificationsProcessSection.signUpCta"
        })
      })]
    })
  });
};
export default CertificationProcessSection;